import React from 'react';
import Table from '../../components/Table';
import { formatDate } from '../../helpers/formatDate';

//import { useHistory } from 'react-router-dom';
const AboDialog = ({ passes }) => {
    //const history = useHistory();

    // const openTicket = (id) => {
    //     history.push(`/etickets/${id}`);
    // };
    return (
        <Table
            isRowClickable={true}
            columns={[
                {
                    Header: 'ID',
                    accessor: 'access_code_id',
                    Cell: ({ value }) => <div>{value}</div>,
                },
                {
                    Header: 'Spiel',
                    accessor: 'opponent',
                    // The crest, with the name kept as the tooltip and as the
                    // fallback for teams that have no logo stored.
                    Cell: ({ value, row }) => (
                        <div>
                            {row.original.opponent_logo ? (
                                <img
                                    src={row.original.opponent_logo}
                                    alt={value || ''}
                                    title={value || ''}
                                    height="40"
                                />
                            ) : (
                                value || '-'
                            )}
                        </div>
                    ),
                },
                {
                    Header: 'Datum',
                    accessor: 'game_date',
                    Cell: ({ value }) => <div>{value ? formatDate(value) : '-'}</div>,
                },
                {
                    Header: 'Bar Code',
                    accessor: 'access_token',
                    Cell: ({ value }) => <div>{value}</div>,
                },
                {
                    Header: 'Platznummer',
                    accessor: 'block_label',
                    Cell: ({ value }) => <div>{value}</div>,
                },
            ]}
            // Chronological, the way a season pass reads. Codes with no game
            // attached yet have nothing to sort by, so they go last.
            data={[...passes]
                .sort((a, b) => {
                    if (!a.game_date) return 1;
                    if (!b.game_date) return -1;
                    return new Date(a.game_date) - new Date(b.game_date);
                })
                .map(
                    ({
                        access_code_id,
                        opponent,
                        opponent_logo,
                        game_date,
                        access_token,
                        block_label,
                    }) => {
                        return {
                            access_code_id,
                            opponent,
                            opponent_logo,
                            game_date,
                            access_token,
                            block_label,
                        };
                    },
                )}
        />
    );
};

export default AboDialog;
